var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33317 33.6668C3.18734 33.6668 2.20678 33.2592 1.3915 32.4439C0.574837 31.6272 0.166504 30.646 0.166504 29.5002V4.50016C0.166504 3.35433 0.574837 2.37377 1.3915 1.5585C2.20678 0.741829 3.18734 0.333496 4.33317 0.333496H37.6665C38.8123 0.333496 39.7936 0.741829 40.6103 1.5585C41.4255 2.37377 41.8332 3.35433 41.8332 4.50016V29.5002C41.8332 30.646 41.4255 31.6272 40.6103 32.4439C39.7936 33.2592 38.8123 33.6668 37.6665 33.6668H4.33317ZM20.9998 19.0835L4.33317 8.66683V29.5002H37.6665V8.66683L20.9998 19.0835ZM20.9998 14.9168L37.6665 4.50016H4.33317L20.9998 14.9168ZM4.33317 8.66683V4.50016V29.5002V8.66683Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.973260b4f8af68d9ced2d23e4a8ae6a1.svg";
export { ForwardRef as ReactComponent };